import { IcMap } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useWindowManager } from '@components/cockpit/WindowManagerContext';
import { Tooltip } from '@components/ui/tooltip';
import { useAppSelector } from '@hooks/redux.hooks';
import { useWithDispatch } from '@hooks/useWithDispatch';
import { selectActiveUser } from '@redux/authent/authent.selectors';
import { selectStatisticsLayoutIdInActiveConfig } from '@redux/config/config.selectors';
import { updateStatisticsCriteria } from '@redux/maps/maps.reducer';
import { selectContext } from '@redux/settings/settings.selectors';
import { usePatchContextMutation } from '@services/config/setting.api';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';

import { ContextEnum } from '@/types/config/screenConfiguration.types';
import { NotificationFamilyEnum } from '@/types/data/data.types';

export function StatisticsActionButton() {
  const { formatMessage } = useIntl();

  const isContextStatistics = useAppSelector(selectContext) === ContextEnum.STAT_DATA;
  const statisticsMapScreenId = useAppSelector(selectStatisticsLayoutIdInActiveConfig, isEqual);
  const hasStatisticsMapInActiveConfig = !!statisticsMapScreenId;
  const dispatchStatisticsCriteria = useWithDispatch(updateStatisticsCriteria);

  const { login } = useAppSelector(selectActiveUser);
  const [patchContext] = usePatchContextMutation();

  const { criteria, filters } = useNotificationSearchContext();
  const { focusOrOpenWindow } = useWindowManager();

  if (filters.category !== NotificationFamilyEnum.LAD) {
    return;
  }

  const handleStatisticAction = () => {
    if (!hasStatisticsMapInActiveConfig) return;

    if (!isContextStatistics) {
      patchContext({ login, context: ContextEnum.STAT_DATA });
    }

    focusOrOpenWindow(statisticsMapScreenId);
    dispatchStatisticsCriteria({ ...criteria, unpaginated: true });
  };

  return (
    <Tooltip
      content={formatMessage({ id: 'components.notificationSearch.statistics.error.context' })}
      disabled={hasStatisticsMapInActiveConfig}
    >
      <IconButton
        variant="cockpitHeader"
        boxSize="56px"
        onClick={handleStatisticAction}
        disabled={!hasStatisticsMapInActiveConfig}
      >
        <Icon as={IcMap} boxSize="24px" />
      </IconButton>
    </Tooltip>
  );
}
